import styled from "styled-components";

const WidgetBox = styled.div`
  border-radius: 2px;
  box-shadow: 0 0 20px 0 rgba(109, 120, 129, 0.16);
  overflow: hidden;
`;

export default WidgetBox;
